import React, { useCallback, useState }  from 'react';
import { useSelector, useDispatch } from 'react-redux'

// SemanticUI components
import { Form, FormGroup, FormInput, FormSelect, Grid, GridRow, GridColumn, Header, HeaderContent, Icon, Card, CardContent, CardGroup, Label, Button, Container, Modal, Segment } from 'semantic-ui-react';

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { setContractData, resetObject, setContractIsLoaded, abortEdit, hideSidebar } from './contractSlice';
import { setActivePage, setUser, setToken, setContractId } from '../../appSlice';

// SystemData
import { options3LC } from './systemdata';
import { optionsAgency } from './systemdata';
import { optionsCategory } from './systemdata';
import { optionsCategoryTO } from './systemdata';
import { optionsHotelchain } from './systemdata';
import { optionsHoteltype } from './systemdata';
import { optionsSeason } from './systemdata';


/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';

// Styles
import './contract.css';


registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractBasicdata = ({editMode}) => {
  // local state
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [contracts, setContracts] = useState([]);

  //global State
  const dispatch = useDispatch();
  const backendUrl    = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const contractData  = useSelector((state) => state.contract.data.Contract);
  const contractId    = useSelector((state) => state.app.contractId);
  const objectID      = useSelector((state) => state.app.objectId);
  
  // Snackbar
    const { enqueueSnackbar } = useSnackbar();

  // Edit mode?
  const readOnly = editMode ? false : true;



  /**
   * Get filtered hotelcodes from server
   * 
   * @param {String} query 
   * @param {String} url 
   *
  const fetchOptions = async (query, url) => {
    setIsLoading(true);
    
    try {
      const api = new AjaxController(url, () => {
            dispatch(setActivePage('START'));
            dispatch(setUser(null));
            dispatch(setToken(null));
          });
      const hotelcodes = await api.get('/hotelcodes/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

      setOptions(hotelcodes);
    } catch (error) {
      console.error("Fehler beim Laden der Optionen:", error);
    }

    setIsLoading(false);
  };



  /**
   * Handle input change in Dropdown
   * 
   * @param {Event} e 
   * @param {String} searchQuery 
   *
  const handleSearchChange = (e, { searchQuery }) => {
    setSearchQuery(searchQuery);

    // Load options after 3 or more characters
    if (searchQuery.length >= 3) {
      fetchOptions(searchQuery, backendUrl);
    } else {
      setOptions([]);
    }
  };
  /**/




  const openSearchModalClick = useCallback(async (hotelcode) => {
    if (!hotelcode) {
      enqueueSnackbar('Kein Hotelcode-Filter übergeben', { variant: 'error' });
      return;
    }

    // Check if backendUrl is defined
    if (!backendUrl) {
      enqueueSnackbar('Backend URL is not defined', { variant: 'error' });
      return;
    }

    // openModal
    setShowSearchModal(true)

    // show loading animation
    setIsLoading(true);

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    // send create pdf request
    let response;
    try {
      response = await api.get('/hotel/' + objectID + '/contracts');
      if (typeof response !== 'undefined' && typeof response.Contracts !== 'undefined') {
        let _contracts = [];
        response?.Contracts.forEach(record => {
          let found = false;
          contractData.Links.SubContracts.forEach(link => {
            if (link.id === record.ContractId) {
              found = true;
            }
          });
          if (record.ContractId !== contractId && contractData.Basics.Season.value === record.SeasonId && !found) {
            _contracts.push(record);
          }
        });
        setIsLoading(false);
        setContracts(_contracts);
        return;
      }
    } catch (error) {
      enqueueSnackbar('Fehler beim Filtern des Veranstaltercodes. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      setIsLoading(false);
      return;
    }
    
    //
    setIsLoading(false);
  }, [backendUrl, contractId, objectID, contractData, dispatch, enqueueSnackbar]);



  const handleOpenContractClick = (cid) => {
    dispatch(hideSidebar());
    dispatch(abortEdit());
    dispatch(resetObject());
    dispatch(setContractIsLoaded(false));
    dispatch(setContractId(cid));
  }



  const linkContractClick = (contract) => {
    const link = {
      id: contract.ContractId, 
      text: '',
      STATUS: contract.Meta.Status,
      Basics: {
          Hotelcode: contract.Hotelcode,
          Hotelname: contract.Hotelname,
          Season: {
              key: contract.SeasonId, 
              value: contract.SeasonId, 
              text: contract.SeasonName, 
          }
        }
    }
    dispatch(setContractData({target: 'Link.Sub', value: link}))

    closeSearchModalClick();
  }



  const unlinkContractClick = (link) => {
    console.log('[link]', link)
    dispatch(setContractData({target: 'Unlink.Sub', value: link.id}))

    closeSearchModalClick();
  }




  const closeSearchModalClick = () => {
    setContracts([]);
    setShowSearchModal(false);
  }




  if (readOnly) {
    return (
      <>
      <Grid>
        <GridRow columns={2}>
          <GridColumn width={6}>
            <Header as='h4'>Vertragsgegenstand und -partner / Objektinformationen</Header>
            <br />
            <Grid>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Saisonbereich</GridColumn><GridColumn width={11}>{contractData.Basics.Season.text}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Zielflughafen</GridColumn><GridColumn width={11}>{contractData.Basics.Destination}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Hotelkette</GridColumn><GridColumn width={11}>{contractData.Basics.HotelChain}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Hotelname</GridColumn><GridColumn width={11}>{contractData.Basics.Hotelname}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Agenturcode</GridColumn><GridColumn width={11}>{contractData.Basics.AgencyCode}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Veranstalter Nummer</GridColumn><GridColumn width={11}>{contractData.Basics.TONumber}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>tourist. Leistung</GridColumn><GridColumn width={11}>{contractData.Basics.TLeistung}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Landeskategorie</GridColumn><GridColumn width={11}>{contractData.Basics.CategoryOff}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Veranstalterkategorie</GridColumn><GridColumn width={11}>{contractData.Basics.CategoryInt}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={5} className='masterdata_ro_label' textAlign='right'>Hoteltyp</GridColumn><GridColumn width={11}>{contractData.Basics.HotelType}</GridColumn></GridRow>
            </Grid>
          </GridColumn>


          <GridColumn width={5}>
            <Header as='h4'>Adresse</Header>
            <br />
            <Grid>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Straße</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Street}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>PLZ</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Postcode}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Stadt</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.City}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Land</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Country}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Telefon</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Phone}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Fax</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Fax}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>E-Mail</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Email}</GridColumn></GridRow>
              <GridRow className='masterdata_ro_row'><GridColumn width={4} className='masterdata_ro_label' textAlign='right'>Webseite</GridColumn><GridColumn width={12}>{contractData.Basics.Contact.Web}</GridColumn></GridRow>
            </Grid>
          </GridColumn>


          <GridColumn width={5}>
            {contractData?.Links?.MainContracts && contractData?.Links?.MainContracts.length 
            ? <>
                <Header as='h4'>Hauptkontingent-Vertrag</Header>
                <CardGroup>
                  {contractData?.Links.MainContracts?.map((link, index) => {
                    let statusColor;
                    let statusText;
                    switch (link.STATUS) {
                      case 1: 
                      case '1': statusColor = 'green'; statusText = 'In Bearbeitung'; break;
                      case 3: 
                      case '3': statusColor = 'orange'; statusText = 'Freigegeben'; break;
                      default:  statusColor = 'grey'; statusText = 'Neu angelegt';  break;
                    }
                    return (
                      <Card fluid color={statusColor} key={index} style={{ maxWidth: '399px' }}>
                        <CardContent style={{background: '#f5f5f5'}}>
                          <Grid columns={2}>
                            <GridRow>
                              <GridColumn width={14}>
                                <Grid columns={2}>
                                  <GridRow>
                                    <GridColumn width={16}>
                                      <Header as='h4'>{link.Basics.Hotelcode}</Header>
                                      {link.Basics.Hotelname}, {link.Basics.Season.value}
                                    </GridColumn>
                                  </GridRow>
                                  <GridRow className='media_ro_row'>
                                    <GridColumn width={4} className='media_ro_label' textAlign='right'>Status:</GridColumn>
                                    <GridColumn width={12}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                  </GridRow>
                                </Grid>
                              </GridColumn>
                              <GridColumn width={2}><Button basic circular floated='right' icon='folder open outline' title='Hauptlkontingent-Vertrag öffnen' onClick={()=>handleOpenContractClick(link.id)}/></GridColumn>
                            </GridRow>
                          </Grid>
                        </CardContent>
                      </Card>
                    )
                  })}
                </CardGroup>
              </>
            : <>
                <Header as='h4'>Teilkontingent-Verträge</Header>
                {(!contractData?.Links?.SubContracts || !contractData?.Links?.SubContracts.length) 
                  ? 
                    <>
                    <Header as='h4' textAlign='center'>
                      <Icon name='times circle outline' />
                      <HeaderContent>Keine Einträge vorhanden</HeaderContent>
                    </Header>
                    <br />
                    </>
                  : 
                    <>
                    <CardGroup>
                      {contractData?.Links.SubContracts?.map((link, index) => {
                        let statusColor;
                        let statusText;
                        switch (link.STATUS) {
                          case 1: 
                          case '1': statusColor = 'green'; statusText = 'In Bearbeitung'; break;
                          case 3: 
                          case '3': statusColor = 'orange'; statusText = 'Freigegeben'; break;
                          default:  statusColor = 'grey'; statusText = 'Neu angelegt';  break;
                        }
                        return (
                          <Card fluid color={statusColor} key={index} style={{ maxWidth: '399px' }}>
                            <CardContent style={{background: '#f5f5f5'}}>
                              <Grid columns={2}>
                                <GridRow>
                                  <GridColumn width={14}>
                                    <Grid columns={2}>
                                      <GridRow>
                                        <GridColumn width={16}>
                                          <Header as='h4'>{link.Basics.Hotelcode}</Header>
                                          {link.Basics.Hotelname}, {link.Basics.Season.value}
                                        </GridColumn>
                                      </GridRow>
                                      <GridRow className='media_ro_row'>
                                        <GridColumn width={4} className='media_ro_label' textAlign='right'>Status:</GridColumn>
                                        <GridColumn width={12}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                      </GridRow>
                                    </Grid>
                                  </GridColumn>
                                  <GridColumn width={2}><Button basic circular floated='right' icon='folder open outline' title='Teilkontingent-Vertrag öffnen' onClick={()=>handleOpenContractClick(link.id)}/></GridColumn>
                                </GridRow>
                              </Grid>
                            </CardContent>
                          </Card>
                        )
                      })}
                    </CardGroup>
                    </>
                }
              </>
            }

          </GridColumn>
        </GridRow>
      </Grid>
      <br />
      </>
    );
  }



  return (
    <>

    {/* Modal für Kopierfunktion */}
    <Modal
      closeIcon
      open={showSearchModal}
      onClose={() => closeSearchModalClick()}
      size='small'
    >
      <Header icon='copy outline' content='Verträge verknüpfen' />
      <Modal.Content>
        {isLoading 
          ? (
            <Segment>
              <Header as='h2' textAlign='center'>
                <Icon loading name='spinner' />
                <HeaderContent>
                  Verträge werden geladen
                </HeaderContent>
              </Header>
            </Segment>
          )
          : (
            <>
              {contracts.length ? (
              <Segment>
                <Header as='h2' textAlign='center'>
                  <HeaderContent>
                    verfügbare Verträge
                  </HeaderContent>
                </Header>
                <Container>
                  <CardGroup>
                    {contracts?.map((contract, index) => {
                      
                      let statusColor;
                      let statusText;
                      switch (contract?.Meta.Status) {
                        case '1':
                        case 1: statusColor = 'green'; statusText = 'In Bearbeitung'; break;
                        case '3': 
                        case 3: statusColor = 'orange'; statusText = 'Freigegeben'; break;
                        default:  statusColor = 'grey'; statusText = 'Neu angelegt';  break;
                      }
                      
                      const fdateStart = format(new Date(contract?.Period?.Start), 'dd.MM.yyyy')
                      const fdateEnd = format(new Date(contract?.Period?.End), 'dd.MM.yyyy')
                      const fdateAt = contract?.Meta?.HistoryAt 
                        ? format(new Date(contract?.Meta?.HistoryAt), 'dd.MM.yyyy, HH:mm') + ' Uhr'
                        : contract?.Meta?.ChangedAt ? format(new Date(contract?.Meta?.ChangedAt), 'dd.MM.yyyy, HH:mm') + ' Uhr' : '';
                      const changedBy = contract?.Meta?.HistoryBy ? contract?.Meta?.HistoryByName : contract?.Meta?.ChangedBy;
                      const changedText = contract?.Meta?.HistoryChange ? ', ' + contract?.Meta?.HistoryChange : '';

                      return (
                        <Card fluid color={statusColor} key={index}>
                          <CardContent style={{background: '#f5f5f5'}}>
                            <Grid columns={2}>
                              <GridRow>
                                <GridColumn width={14}>
                                  <Grid columns={2}>
                                    <GridRow>
                                      <GridColumn width={16}>
                                        <Header as='h4'>{contract.Hotelcode}</Header>
                                        {contract.Hotelname}, {contract.SeasonId}
                                      </GridColumn>
                                    </GridRow>
                                    <GridRow className='media_ro_row'>
                                      <GridColumn width={4} className='media_ro_label' textAlign='right'>Status:</GridColumn>
                                      <GridColumn width={12}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                    </GridRow>
                                    <GridRow className='media_ro_row'>
                                      <GridColumn width={4} className='media_ro_label' textAlign='right'>Laufzeit:</GridColumn>
                                      <GridColumn width={12}>{fdateStart} - {fdateEnd}</GridColumn>
                                    </GridRow>
                                    <GridRow className='media_ro_row'>
                                      <GridColumn width={4} className='media_ro_label' textAlign='right'>Änderung:</GridColumn>
                                      <GridColumn width={12} title={contract.Meta.Changed}>{fdateAt}, {changedBy}{changedText}</GridColumn>
                                    </GridRow>
                                  </Grid>
                                </GridColumn>
                                <GridColumn width={2}><Button basic circular floated='right' icon='linkify' title='Vertrag als Teilkontingent verknüpfen' onClick={()=>linkContractClick(contract)} /></GridColumn>
                              </GridRow>
                            </Grid>
                          </CardContent>
                        </Card>
                      )
                    })}
                  </CardGroup>
                </Container>
              </Segment>
            ) 
            : (
              <Segment>
                <Header as='h2' textAlign='center'>
                  <HeaderContent>
                    keine verfügbaren Verträge gefunden
                  </HeaderContent>
                </Header>
                {/* 
                <Container textAlign='center'>
                  <br />
                  <Button basic circular icon labelPosition='left' style={{marginBottom: '20px'}} onClick={()=>openSearchModalClick('AGP10B')}><Icon name='add' />Neuen Vertrag als Teilkontingent hinzufügen</Button>
                  <Button basic circular icon labelPosition='left' style={{marginBottom: '20px'}} onClick={()=>openSearchModalClick('AGP10B')}><Icon name='copy outline' />Vertragskopie als Teilkontingent hinzufügen</Button>
                  <br />
                </Container>
                */}
              </Segment>
            )
          }
            </>
          )
        }
      </Modal.Content>
    </Modal>


    <Grid>
      <GridRow columns={3}>
        <GridColumn width={6}>
          <Header as='h4'>Vertragsgegenstand und -partner / Objektinformationen</Header>
          <Form>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label='Saisonbereich' readOnly={readOnly} value={contractData.Basics.Season.value} options={optionsSeason} placeholder='Saisonbereich' onChange={(e, data) => dispatch(setContractData({target: 'Basics.Season', value: data.value}))} />
              <FormSelect fluid search selection label='Zielflughafen' readOnly={readOnly} value={contractData.Basics.Destination}  options={options3LC}    placeholder='Zielflughafen' onChange={(e, data) => dispatch(setContractData({target: 'Basics.Destination', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label='Hotelkette' readOnly={readOnly} value={contractData.Basics.Hotelchain} options={optionsHotelchain} placeholder='Hotelkette' onChange={(e, data) => dispatch(setContractData({target: 'Basics.Hotelchain', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormInput fluid                   label='Hotelname'              readOnly={readOnly} value={contractData.Basics.Hotelname}                               placeholder='Hotelname'  onChange={(e, data) => dispatch(setContractData({target: 'Basics.Hotelname', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label='Agenturcode'            readOnly={readOnly} value={contractData.Basics.AgencyCode}  options={optionsAgency}     placeholder='Agenturcode'         onChange={(e, data) => dispatch(setContractData({target: 'Basics.AgencyCode', value: data.value}))} />
              <FormInput fluid                   label='Veranstalter Nummer'    readOnly={readOnly} value={contractData.Basics.TONumber}                                placeholder='Veranstalter Nummer' onChange={(e, data) => dispatch(setContractData({target: 'Basics.TONumber', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label='Hoteltyp'               readOnly={readOnly} value={contractData.Basics.HotelType}   options={optionsHoteltype}  placeholder='Hoteltyp'              onChange={(e, data) => dispatch(setContractData({target: 'Basics.HotelType', value: data.value}))} />
              <FormInput fluid                   label='tourist. Leistung'      readOnly={readOnly} value={contractData.Basics.TLeistung}                               placeholder='tourist. Leistung'   onChange={(e, data) => dispatch(setContractData({target: 'Basics.TLeistung', value: data.value}))} />
            </FormGroup>
            <FormGroup widths='equal'>
              <FormSelect fluid search selection label='Landeskategorie'        readOnly={readOnly} value={contractData.Basics.CategoryOff} options={optionsCategory}   placeholder='Landeskategorie'       onChange={(e, data) => dispatch(setContractData({target: 'Basics.CategoryOff', value: data.value}))} />
              <FormSelect fluid search selection label='Veranstalterkategorie'  readOnly={readOnly} value={contractData.Basics.CategoryInt} options={optionsCategoryTO} placeholder='Veranstalterkategorie' onChange={(e, data) => dispatch(setContractData({target: 'Basics.CategoryInt', value: data.value}))} />
            </FormGroup>
          </Form>
        </GridColumn>

        <GridColumn width={5}>
          <Form>
            <Header as='h4'>Adresse</Header>
            <FormInput fluid label='Straße'   readOnly={readOnly} value={contractData.Basics.Contact.Street}    placeholder='Straße' onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.Street', value: data.value}))} />
            <FormGroup>
              <FormInput fluid label='PLZ'    readOnly={readOnly} value={contractData.Basics.Contact.Postcode}  placeholder='PLZ'   width={5}  onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.Postcode', value: data.value}))} />
              <FormInput fluid label='Stadt'  readOnly={readOnly} value={contractData.Basics.Contact.City}      placeholder='Stadt' width={11} onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.City', value: data.value}))} />
            </FormGroup>
            <FormInput fluid label='Land'     readOnly={readOnly} value={contractData.Basics.Contact.Country}   placeholder='Land'    onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.Country', value: data.value}))} />
            <FormInput fluid label='Telefon'  readOnly={readOnly} value={contractData.Basics.Contact.Phone}     placeholder='Telefon' onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.Phone', value: data.value}))} />
            <FormInput fluid label='Fax'      readOnly={readOnly} value={contractData.Basics.Contact.Fax}       placeholder='Fax'     onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.Fax', value: data.value}))} />
            <FormInput fluid label='Email'    readOnly={readOnly} value={contractData.Basics.Contact.Email}     placeholder='Email'   onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.Email', value: data.value}))} />
            <FormInput fluid label='Website'  readOnly={readOnly} value={contractData.Basics.Contact.Web}       placeholder='Website' onChange={(e, data) => dispatch(setContractData({target: 'Basics.Contact.Web', value: data.value}))} />
          </Form>
        </GridColumn>
          
        <GridColumn width={5}>
          {(contractData?.Links?.MainContracts && contractData?.Links?.MainContracts.length) 
          ? <></>
          : <>
            <Header as='h4'>Teilkontingent-Verträge</Header>
            {(!contractData?.Links?.SubContracts || !contractData?.Links?.SubContracts.length) 
              ? 
                <>
                <Header as='h4' textAlign='center'>
                  <Icon name='times circle outline' />
                  <HeaderContent>Keine Einträge vorhanden</HeaderContent>
                </Header>
                <br />
                </>
              : 
                <>
                <CardGroup>
                  {contractData?.Links?.SubContracts?.map((link, index) => {
                    let statusColor;
                    let statusText;
                    switch (link.STATUS) {
                      case 1: 
                      case '1': statusColor = 'green'; statusText = 'In Bearbeitung'; break;
                      case 3: 
                      case '3': statusColor = 'orange'; statusText = 'Freigegeben'; break;
                      default:  statusColor = 'grey'; statusText = 'Neu angelegt';  break;
                    }
                    return (
                      <Card fluid color={statusColor} key={index} style={{ maxWidth: '399px' }}>
                        <CardContent style={{background: '#f5f5f5'}}>
                          <Grid columns={2}>
                            <GridRow>
                              <GridColumn width={14}>
                                <Grid columns={2}>
                                  <GridRow>
                                    <GridColumn width={16}>
                                      <Header as='h4'>{link.Basics.Hotelcode}</Header>
                                      {link.Basics.Hotelname}, {link.Basics.Season.value}
                                    </GridColumn>
                                  </GridRow>
                                  <GridRow>
                                    <GridColumn width={5} textAlign='right'>Status:</GridColumn>
                                    <GridColumn width={11}><Label circular size='tiny' color={statusColor}>&nbsp;{statusText}&nbsp;</Label></GridColumn>
                                  </GridRow>
                                </Grid>
                              </GridColumn>
                              <GridColumn width={2}><Button basic circular floated='right' icon='unlinkify' onClick={()=>unlinkContractClick(link)} /></GridColumn>
                            </GridRow>
                          </Grid>
                        </CardContent>
                      </Card>
                    )
                  })}
                </CardGroup>    
                </>
            }
            <br />
            <Button basic circular icon labelPosition='left' onClick={()=>openSearchModalClick('AGP10B')}><Icon name='add' />Verknüpfung hinzufügen</Button>
            </>
          }
        </GridColumn>
      </GridRow>
    </Grid>
    </>
  );
}

export default Max2ContractBasicdata;